import React from "react";

import usePsnorder from "../../hooks/usePsnorder";

import { Box, Button, Spinner, Text, TextInput } from "grommet";
import groupObject from "../../functions/groupObject";
import { CaretRightFill } from "grommet-icons";
import { useNavigate } from "react-router-dom";

const GazetteBook = (props: any) => {
    const { bookid } = props;
    const [received, setReceived] = React.useState(false);
    const [psnorder, setPsnorder] = React.useState<any>([]);
    const [ready, setReady] = React.useState(false);

    const [poDate, setPoDate] = React.useState<any>(null);
    const [poDateDict, setPoDateDict] = React.useState<any>({});

    const navigate = useNavigate();

    React.useEffect(() => {
        const receiveData = async () => {
            console.log("bookid in GazetteBook", bookid)
            setPoDate(null);
            setPoDateDict({});
            const res = await usePsnorder.getPsnordersByBookId(bookid);
            if (res) {
                let psnorder = res.psnorders.sort((a: any, b: any) => {
                    let a_year = a.po_year;
                    let b_year = b.po_year;
                    if (a_year === null) a_year = 0;
                    if (b_year === null) b_year = 0;

                    let a_month = a.po_month;
                    let b_month = b.po_month;
                    if (a_month === null) a_month = 0;
                    if (b_month === null) b_month = 0;
                    let a_day = a.po_day;
                    let b_day = b.po_day;
                    if (a_day === null) a_day = 0;
                    if (b_day === null) b_day = 0;

                    if (a_year !== b_year) {
                        return a_year - b_year;
                    } else if (a_month !== b_month) {
                        return a_month - b_month;
                    } else {
                        return a_day - b_day;
                    }
                });
                setPsnorder(psnorder);
                setReceived(true);
            }
        };
        receiveData();
    }, [bookid]);

    React.useEffect(() => {
        if (psnorder.length > 0) {
            // group psnorder by po_date
            let psnorderGroup = groupObject(psnorder, "po_date");
            console.log(psnorderGroup);

            // make date list from psnorderGroup keys
            let poDate = Object.keys(psnorderGroup);
            console.log(poDate);
            setPoDate(poDate);
            setPoDateDict(psnorderGroup);
            setReady(true);
        }
    }, [bookid, received]);

    const PoList = (props:any)=>{
        const {d} = props
        return (
            <Box>
                <Box direction='row' margin={{bottom:'5px', top:'15px'}} >
                    <CaretRightFill size='16px'/>
                    <Text size='16px' weight='bold'>{d}</Text>
                </Box>
                {poDateDict[d].map((p: any, index: number) => {
                    return (
                        <Box direction='row' align='start' justify='start'
                            key={index} margin={{vertical:'2px', horizontal:'15px'}}>
                            <Text size='15px' margin={{horizontal:'5px'}}>-</Text>
                            <Text>
                               {p.status_text && p.status_text.length>1&&<Text size="15px" margin={{ right: "5px" }}>
                                    {p.status_text}
                                </Text>}
                                <Button
                                    margin={{ right: "5px" }}
                                    plain
                                    label={
                                        <Text color="indigo" size="15px">
                                            {p.personname}
                                        </Text>
                                    }
                                    onClick={()=>{navigate("/person#"+p.person_id)}}
                                />
                                <Text size="15px">{p.order_text}</Text>
                            </Text>
                        </Box>
                    );
                })}
            </Box>
        );
    }

    return (
        <>
            {!poDate ? (
                <Spinner />
            ) : (
                <Box width='full'
                    background={'rgba(255,255,255,0.8)'}
                    pad='10px'
                >
                    {poDate.map((date: any, index: number) => {
                        return (
                        <Box key={index}>
                            <PoList d={date}/>
                        </Box>
                        );
                    })}
                </Box>
            )}
        </>
    );
};

export default GazetteBook;
